import React from 'react';
import { useIntl } from 'react-intl';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import SeverityIcon from '~/components/SeverityIcon';
import ListItemButton from '@mui/material/ListItemButton';
import messages from './messages';

const getNumberOfErrors = (
  issues: Array<{
    type?: string | null;
    severity?: string | null;
  }>
) => issues.filter((issue) => issue.severity === 'Error').length;

const getNumberOfWarnings = (
  issues: Array<{
    type?: string | null;
    severity?: string | null;
  }>
) => issues.filter((issue) => issue.severity === 'Warning').length;

type RightIconProps = {
  turn: {
    isEnabled: boolean;
    isCanceled: boolean;
  };
  numberOfErrors: number;
  numberOfWarnings: number;
  style?: React.CSSProperties;
  color?: React.ComponentProps<typeof CheckIcon>['color'];
};

export const RightIcon = (props: RightIconProps) => {
  if (props.turn.isCanceled)
    return <CancelIcon style={props.style} color="disabled" />;
  if (props.numberOfErrors > 0)
    return <SeverityIcon severity="Error" style={props.style} />;
  if (props.numberOfWarnings > 0)
    return <SeverityIcon severity="Warning" style={props.style} />;
  if (props.turn.isEnabled)
    return <CheckIcon style={props.style} color={props.color} />;
  return null;
};

type ShiftDetailCardRouteItemProps = {
  onPlanRoute: (id: number) => void;
  turn: {
    id: number;
    isEnabled: boolean;
    isCanceled: boolean;
    route: {
      name: string;
    };
    turnAssignments: Array<number>;
  };
  issues: Array<{
    type?: string | null;
    severity?: string | null;
  }>;
};

export const ShiftDetailCardRouteItem = (
  props: ShiftDetailCardRouteItemProps
) => {
  const intl = useIntl();
  const numberOfErrors = getNumberOfErrors(props.issues);
  const numberOfWarnings = getNumberOfWarnings(props.issues);
  return (
    <ListItemButton
      key={props.turn.id}
      onClick={() => props.onPlanRoute(props.turn.id)}
    >
      <ListItemText
        primary={<span>{props.turn.route.name}</span>}
        secondary={
          props.turn.isEnabled
            ? intl.formatMessage(messages.issues, {
                errorCount: numberOfErrors,
                warningCount: numberOfWarnings,
                numberOfAssignments: props.turn.turnAssignments.length,
              })
            : null
        }
      />
      <ListItemSecondaryAction>
        <RightIcon
          turn={props.turn}
          numberOfErrors={numberOfErrors}
          numberOfWarnings={numberOfWarnings}
        />
      </ListItemSecondaryAction>
    </ListItemButton>
  );
};

export default ShiftDetailCardRouteItem;
